export const descriptionStyles: React.CSSProperties = {
  textAlign: 'center',
  letterSpacing: '-0.03em',
  marginBottom: '32px',
  fontFamily: 'Poppins,sansSerif',
  fontSize: '0.875rem',
  fontWeight: '500',
  lineHeight: '1.4',
  color: 'var(--fuel-color-text-medium)',
};

export const titleStyles: React.CSSProperties = {
  marginTop: '56px',
  marginBottom: '8px',
  color: 'var(--fuel-color-text-strong)',
  fontSize: '1.5rem',
  fontWeight: '600',
  lineHeight: '1.32',
  letterSpacing: '-0.03em',
};

export const buttonStyles: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  whiteSpace: 'nowrap',
  borderRadius: '12px',
  padding: '0px 16px',
  cursor: 'pointer',
  fontSize: '0.875rem',
  fontWeight: '600',
  border: 'var(--fuel-color-border-weak)',
  width: 'auto',
  height: '48px',
  color: 'var(--fuel-color-text-inverted)',
  background: 'var(--fuel-color-surface-primary)',
};

export const wrapperStyles: React.CSSProperties = {
  marginTop: '64px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  fontFamily: 'Poppins, sans-serif',
};
